import { useCookies as useReactCookies } from 'react-cookie';

export enum Cookies {
  CookiesAccepted = 'ca'
}

const useCookies = (
  name: Cookies
): {
  name: string | undefined;
  setCookie: (cName: Cookies, cValue: string, cExpires?: Date) => void;
  removeCookie: (name: string) => void;
} => {
  const [cookies, setCookies, removeCookie] = useReactCookies([name]);
  const domainName: string =
    process.env.NODE_ENV === 'development'
      ? ''
      : `${process.env.REACT_APP_PROD_DOMAIN}`;
  const setDefinedCookie = (cName: Cookies, cValue: string, expires?: Date) => {
    const expirationDate = expires ? { epires: expires } : null;
    setCookies(cName, cValue, {
      domain: domainName,
      ...expirationDate
    });
  };
  const removeDefinedCookie = () => removeCookie(name, { domain: domainName });
  const parsedCookie = Object.entries(cookies).find(el => el[0] === name);
  return {
    name: typeof parsedCookie !== 'undefined' ? parsedCookie[1] : undefined,
    setCookie: setDefinedCookie,
    removeCookie: removeDefinedCookie
  };
};

export default useCookies;
